// extracted by mini-css-extract-plugin
export default {"teamViewForm":"TeamEditView_teamViewForm__BhCIl","buttonContainer":"TeamEditView_buttonContainer__ZIkLP"};